import React from 'react';
import PartyMaster from './PartyMaster';

function BorderCuttingParties() {
  return (
    <PartyMaster
      title="Border Cutting Parties"
      modalTitle="Add Border Cutting Party"
      addButtonText="Add Border Cutting Party"
      searchPlaceholder="Search border cutting parties..."
      partyCategory="BORDER_CUTTING_PARTIES"
      namePlaceholder="Border cutting party name"
    />
  );
}

export default BorderCuttingParties;
